import { render, staticRenderFns } from "./ExpandedClass.vue?vue&type=template&id=06d93236&scoped=true"
import script from "./ExpandedClass.vue?vue&type=script&lang=js"
export * from "./ExpandedClass.vue?vue&type=script&lang=js"
import style0 from "./ExpandedClass.vue?vue&type=style&index=0&id=06d93236&prod&lang=sass"
import style1 from "./ExpandedClass.vue?vue&type=style&index=1&id=06d93236&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d93236",
  null
  
)

export default component.exports